import React from "react";
import { reduxForm } from "redux-form";
import { injectIntl, FormattedMessage } from "react-intl";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from 'classnames';
import { connect } from "react-redux";
import CurrencyConverter from '../CurrencyConverter/CurrencyConverter';
import PaymentFormSkeleton from "../Skeleton/ViewBooking/PaymentFormSkeleton/PaymentFormSkeleton";
import Link from "../Link/Link";
import submit from "./submit";
import messages from "../../locale/messages";
import { openHeaderModal, closeHeaderModal } from "../../actions/siteadmin/modalActions";
import { removeCardDetailsAction } from "../../actions/payment/removeCardDetialsAction";
import RadioFieldComponent from "../Common/RadioFieldComponent/RadioFieldComponent";

import { CardDeleteIcon, CardEditIcon, LinkPlusIcon } from "../Common/Assets/SVGIcon/CommonSvgIcon";
import cashIcon from '../../../public/Icons/cash.png';
import cardIcon from '../../../public/Icons/cards.png';
import walletIcon from '../../../public/Icons/wallet.png';
import paypalIcon from '../../../public/Icons/paypal.png';

import bt from "../../components/commonStyle.css";
import s from './PaymentMethodForm.css';


function PaymentMethodForm(props) {

    const {
        paymentMethods,
        userPaymentMethod,
        currency,
        handleSubmit,
        paymentMethodLoading,
        change,
        intl: { formatMessage },
        removeCardDetailsAction,
    } = props

    const enabledPaymentMethods = paymentMethods?.getAllPaymentMethods?.results?.filter(method => method.isEnable);
    const walletAmount = userPaymentMethod?.getPaymentMethod?.result?.walletBalance;
    const isPaymentMethod = userPaymentMethod?.getPaymentMethod?.result?.paymentMethodId;
    const isPaymentId = enabledPaymentMethods?.filter(o => o.id === 2 || o.id === 5);
    const formData = {
        isWallet: true,
        walletAmount,
        isPaymentId: isPaymentId?.length == 1 && isPaymentId[0]?.paymentType || null
    };

    const handleRadioChange = async (event) => {
        await change("paymentMethodId", event.target.value);
        handleSubmit(submit)();
    };

    const renderCardDetails = () => {
        const lastFourDigits = userPaymentMethod?.getPaymentMethod?.result?.cardLastFour;
        return (
            <div className={s.cardNumberShow}>
                <span className={cx(bt.commonSize14, bt.fontWeight600)}>**** **** **** {lastFourDigits}</span>
                <div className={s.editDeleteRow}>
                    <Link to={'/add-card'} className={s.cardEditDeleteBtn}>
                        <CardEditIcon />
                    </Link>
                    <span onClick={removeCardDetailsAction} className={s.cardEditDeleteBtn}>
                        <CardDeleteIcon />
                    </span>
                </div>
            </div>
        );
    };
    if (paymentMethodLoading) {
        return <PaymentFormSkeleton />
    }
    return (
        <div>
            <div className={s.paymentSectionWrapper}>
                <p className={s.sectionTitle}><FormattedMessage {...messages.paymentMethodText} /></p>
                <form onSubmit={handleSubmit(submit)}>
                    <div className={s.paymentCardBox}>
                        {enabledPaymentMethods?.filter(method => method.paymentType === 2 || method.paymentType === 3).map(method => (
                            <div key={method?.id}>
                                <div className={s.paymentCardSection}>
                                    <div className={cx(s.cardLabel, s.cardMiddleLine, bt.space2)}>
                                        <div className={s.labelFlex}>
                                            <img src={method.paymentType === 2 ? cardIcon : walletIcon} alt="cardIcon"
                                                className={s.paymentPlatformIcon} />
                                            <div className="">
                                                <FormattedMessage {...(method.paymentType === 2 ? messages.creditOrDebit : messages.walletText)} />&nbsp;
                                                {method.paymentType === 3 && <CurrencyConverter amount={walletAmount} from={currency} />}
                                            </div>
                                        </div>
                                        <RadioFieldComponent
                                            name="paymentMethodId"
                                            value={method.paymentType.toString()}
                                            onChange={(e) => handleRadioChange(e)}
                                            size={24}
                                            isTick />
                                    </div>
                                    {method?.paymentType === 2 && ((isPaymentMethod != null && isPaymentMethod != 0) ? renderCardDetails()
                                        :
                                        <Link to={'/add-card'} className={bt.customLink}>
                                            <LinkPlusIcon />
                                            <FormattedMessage {...messages.addCard} />
                                        </Link>

                                    )}
                                    {method.paymentType === 3 && (
                                        <Link to={'/add-wallet'} className={bt.customLink}>
                                            <LinkPlusIcon />
                                            <FormattedMessage {...messages.addWallet} />
                                        </Link>
                                    )}
                                </div>
                            </div>
                        ))}
                        <>
                            {enabledPaymentMethods?.filter(method => method.paymentType === 1).map(method => (
                                <div key={method?.id}>
                                    <div className={cx(s.paymentCardSection)}>
                                        <div className={cx(s.cardLabel)}>
                                            <div className={s.labelFlex}>
                                                <img src={cashIcon} alt="cashIcon" className={s.paymentPlatformIcon} />
                                                <FormattedMessage {...messages.cash} />
                                            </div>
                                            <RadioFieldComponent
                                                name="paymentMethodId"
                                                value="1"
                                                onChange={(e) => handleRadioChange(e)}
                                                size={24}
                                                isTick />
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {enabledPaymentMethods?.filter(method => method.paymentType === 5).map(method => (
                                <div key={method?.id}>
                                    <div className={cx(s.paymentCardSection)}>
                                        <div className={cx(s.cardLabel)}>
                                            <div className={s.labelFlex}>
                                                <img src={paypalIcon} alt="paypalIcon" className={s.paymentPlatformIcon} />
                                                <FormattedMessage {...messages.paypalLabel} />
                                            </div>
                                            <RadioFieldComponent
                                                name="paymentMethodId"
                                                value={method.paymentType.toString()}
                                                onChange={(e) => handleRadioChange(e)}
                                                size={24}
                                                isTick />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>
                    </div>
                </form>
            </div>
        </div>
    );
}

PaymentMethodForm = reduxForm({
    form: 'PaymentMethodForm',
    onSubmit: submit,
    enableReinitialize: true,
})(PaymentMethodForm)


const mapState = (state) => ({
    currency: state?.userAccount?.data?.preferredCurrency,

});

const mapDispatch = {
    openHeaderModal,
    closeHeaderModal,
    removeCardDetailsAction
};

export default injectIntl(
    withStyles(bt, s)(
        connect(mapState, mapDispatch)(PaymentMethodForm)
    )
);
